import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr2014',
    ecrans: ['00-2'],
    params: ['?demcleint','?unpcleint','?ppacleint']
});
